import { type ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthStore } from '../stores';

interface ProtectedRouteProps {
  children: ReactElement;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated, hasHydrated, isLoading } = AuthStore.useAuthStore();
  const location = useLocation();


  if (!hasHydrated || isLoading) return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-lg">Loading...</div>
    </div>
  );


  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;